import dayjs from 'dayjs';

// to ms
export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const YEAR = 365 * DAY;

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const MAX_TIMEOUT = 5 * MINUTE;

export function formatDuration(ms: number): string {
  const dur = dayjs.duration(ms);
  let str = '';
  const days = dur.days();
  const hours = dur.hours();
  const minutes = dur.minutes();
  const seconds = dur.seconds();

  if (days > 0) {
    str += `${days} day${days > 1 ? 's' : ''} `;
  }
  if (hours > 0) {
    str += `${hours} hour${hours > 1 ? 's' : ''} `;
  }
  if (minutes > 0) {
    str += `${minutes} minute${minutes > 1 ? 's' : ''} `;
  }
  if (seconds > 0) {
    str += `${seconds} second${seconds > 1 ? 's' : ''}`;
  }

  return str.trim();
}
